import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {ConfirmAccountSection} from '@features/user/components/confirm-account-section'
import {Container} from '@components/ui/container'
import {Header} from '@components/commons/header'
import {Button} from '@components/ui/button'
import {usePhotographersSsoConfigured} from '@features/user/queries/usePhotographersSsoConfigured'
import {Spinner} from '@components/ui/spinner'
import {routes} from '@utilities/constants/routes'
import {useNavigate} from 'react-router-dom'
import {usePhotographersSsoLogout} from '@features/user/queries/usePhotographersSsoLogout'
import {useMe} from '@features/user/queries/useMe'
import {isReviewerOnly} from '@features/user/utils'

export const LinkAirbnbAccountConfirm = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const meQuery = useMe({throwOnError: true})
    const photographersSsoConfiguredMutation = usePhotographersSsoConfigured({
        onSuccess: () => {
            navigate(
                meQuery.data?.lastMarketsUpdatedAt || (meQuery.data && isReviewerOnly(meQuery.data))
                    ? routes.HOME.handle.fullPath
                    : routes.MARKETS_CONFIGURATION.handle.fullPath
            )
        }
    })

    const photographersSsoLogoutMutation = usePhotographersSsoLogout({
        onSuccess: () => {
            navigate(routes.LINK_AIRBNB_ACCOUNT.handle.fullPath)
        }
    })

    if (meQuery.isPending) {
        return (
            <div className="flex justify-center items-center h-full w-full">
                <Spinner size={40} />
            </div>
        )
    }

    return (
        <div className="grid grid-rows-[auto_minmax(0,1fr)] overflow-hidden h-full bg-white">
            <Header isPrivate={false} />

            <div className="overflow-y-auto h-full grid grid-rows-[1fr_auto] grid-cols-1">
                <Container className="pt-20 pb-20 flex justify-center items-center">
                    <div className="flex flex-col gap-8 w-full max-w-120 mx-auto ">
                        <ConfirmAccountSection />

                        <p className="text-center text-lg text-black">
                            <Trans
                                i18nKey="link_airbnb_account:sign_in_description"
                                components={{b: <b className="text-md font-medium text-black" />}}
                            />
                        </p>
                    </div>
                </Container>
                <div className="border-t border-neutral-200 p-4 flex items-center justify-center h-auto">
                    <div className="flex flex-row justify-between gap-2 w-full max-w-150 mx-auto">
                        <Button
                            variant="tertiary"
                            shape="text"
                            onClick={() => photographersSsoLogoutMutation.mutate()}
                            disabled={
                                photographersSsoLogoutMutation.isPending || photographersSsoConfiguredMutation.isPending
                            }
                        >
                            {t('link_airbnb_account:use_another_airbnb_profile')}
                            {photographersSsoLogoutMutation.isPending && <Spinner />}
                        </Button>
                        <Button
                            onClick={() => photographersSsoConfiguredMutation.mutate()}
                            disabled={
                                photographersSsoLogoutMutation.isPending || photographersSsoConfiguredMutation.isPending
                            }
                        >
                            {t('commons:continue')}
                            {photographersSsoConfiguredMutation.isPending && <Spinner />}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
